import { createContext, useContext } from 'react';

export const FeaturedPlanIdsContext = createContext<string[]>([]);

export function useFeaturedPlanIds(): string[] {
  return useContext(FeaturedPlanIdsContext);
}
